import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';

const DEFAULT_STATE = Immutable([]);

export default function(state = DEFAULT_STATE, action = {}) {
  let array;
  switch (action.type) {
    case ActionTypes.PROJECTS_CONNECT_ACTIVITY_CREATED:
      array = Immutable.asMutable(state.concat([action.connectActivity]));
      array.sort((a, b) => b.timestamp.localeCompare(a.timestamp));
      return Immutable(array);
    case ActionTypes.PROJECTS_CONNECT_ACTIVITY_CLEAR:
      return DEFAULT_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projectConnectActivity.js